const parameterList = [  
  {
    name: "Speed",
    min: 0,
    max: 5,
    variable: "uSpeed",
    step: 0.01
  },
  {
    name: "Frequency",
    min: 0.01,
    max: 0.5,
    variable: "uFrequency",
    step: 0.001
  },
  {
    name: "Amplitude",
    min: 0.01,
    max: 40,
    variable: "uAmplitude",
    step: 0.01
  }
]

const count = {
  name: "Size",
  min: 1,
  max: 100
}

export default function createAnimationUi(world){
  const animation = document.getElementById('animation')

  // ======== //
  // Uniforms //
  // ======== //
  for (let parameter of parameterList){
    // Html Elem
    const htmlP = createTextElem(parameter.name)
    const htmlSlider = createSliderElem(parameter.min, parameter.max, parameter.step)
    
    // Event
    htmlSlider.value = world.uniforms[parameter.variable].value
    htmlSlider.addEventListener('input', () => {
      world.uniforms[parameter.variable].value = htmlSlider.value

      if(parameter.name == 'Amplitude'){
        world.refreshWater()
      }
    })

    // Populate
    animation.appendChild(htmlP)
    animation.appendChild(htmlSlider)
  }

  // Count
  const htmlP = createTextElem(count.name)
  const htmlSlider = createSliderElem(count.min, count.max, 1)

  // Event
  htmlSlider.value = world.mapSize
  htmlSlider.addEventListener('change', () => {
    world.updateSize(htmlSlider.value)
  })

  // Populate
  animation.appendChild(htmlP)
  animation.appendChild(htmlSlider)

  // ======== //
  // Polygons //
  // ======== //
  const statsBody = document.createElement('div')

  // Titles
  const titles = document.createElement('div')

  const hexagonTitle = document.createElement('p')
  hexagonTitle.innerText = "Meshes"

  const verticesTitle = document.createElement('p')
  verticesTitle.innerText = "Vertices"

  titles.appendChild(hexagonTitle)
  titles.appendChild(verticesTitle)

  // Stats
  const stats = document.createElement('div')

  const hexagonStats = document.createElement('p')
  const verticesStats = document.createElement('p')

  stats.appendChild(hexagonStats)
  stats.appendChild(verticesStats)

  statsBody.appendChild(titles)
  statsBody.appendChild(stats)

  animation.appendChild(statsBody)

  statsBody.id = "statsBody"
  hexagonStats.id = "hexagonCount"
  verticesStats.id = "verticesCount"

  // ===== //
  // Water //
  // ===== //
  const waterCheck = document.createElement('div')
  const check = document.createElement('div')
  const text = document.createElement('p')

  waterCheck.id = "waterCheck"
  check.id = "check"
  text.id = "checkText"

  text.innerText = "Display Water"

  let isWaterShow = true
  check.addEventListener('click', () => {
    if(isWaterShow) {
      isWaterShow = false
      check.style.backgroundColor = "white"
      world.water.material.opacity = 0
    }
    else{
      isWaterShow = true
      check.style.backgroundColor = "black"
      world.water.material.opacity = 0.9
    }
  })

  waterCheck.append(check)
  waterCheck.append(text)
  animation.appendChild(waterCheck)
}

function createTextElem(text){
  const elem = document.createElement('p')
  elem.innerText = text
  elem.className = "animText"
  
  return elem
}

function createSliderElem(min, max, step){
  const elem = document.createElement('input')
  elem.type = "range"
  elem.min = min
  elem.max = max
  elem.step = step
  elem.className = "animSlider"

  return elem
}